"use client";
import { Box, Link } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SpaceLg, SpaceMd, ColorWhite, ColorCostcoBlue, FontLineHeightSm, FontWeightBold, FontSize600, SpaceXxs, ColorBlack, BpSm } from "@nxt-costco-com/forge-design-tokens";
import GenericImageHandler from "../../Util/GenericImageHandler.js";
const HEADER_HEIGHT = 224;
const HEADER_ICON_HEIGHT = 77;
const HEADER_ICON_CONTAINER_SIZE = 120;
const DEFAULT_CALLOUT_BACKGROUND_COLOR = "#d32029";
const DEFAULT_CALLOUT_TEXT_COLOR = ColorWhite;
const MAX_TILE_WIDTH = 448;
const MEDIA_QUERY_SMALL = `@media (max-width: ${BpSm})`;
const StyledTileContainer = styled(Box)({
  width: "100%"
});
const StyledHeaderContainer = styled(Box)({
  alignItems: "center",
  backgroundPosition: "center",
  backgroundSize: "cover",
  display: "flex",
  height: HEADER_HEIGHT,
  justifyContent: "center"
});
const StyledBodyContainer = styled(Box)({
  alignContent: "center",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  padding: `${SpaceLg} ${SpaceMd}`,
  textAlign: "center"
});
const StylesIconContainer = styled(Box)({
  alignItems: "center",
  backgroundColor: ColorWhite,
  borderRadius: HEADER_ICON_CONTAINER_SIZE / 2,
  display: "flex",
  height: HEADER_ICON_CONTAINER_SIZE,
  justifyContent: "center",
  width: HEADER_ICON_CONTAINER_SIZE
});
const StyledLinkContainer = styled(Link)({
  "&:focus": {
    outline: "2px solid -webkit-focus-ring-color",
    outlineOffset: 2
  },
  "&:hover": {
    "& .overlay-icon": {
      "@media (prefers-reduced-motion)": {
        transform: "none"
      },
      transform: "scale(1.2)",
      transition: "transform .2s linear"
    },
    "& img": {
      transform: "translateY(-5px)"
    },
    cursor: "pointer",
    outline: "none",
    textDecoration: "none"
  },
  "@media (prefers-reduced-motion)": {
    transform: "none"
  },
  borderRadius: 10,
  display: "block",
  fontFamily: '"GothamMedium", "Helvetica Neue", "Helvetica Neue LT Pro", Helvetica, arial, sans-serif',
  height: "100%",
  overflow: "hidden",
  textDecoration: "none"
});
const StyledStaticCalloutContainer = styled(Box)({
  "& div": {
    textAlign: "left"
  },
  "& h2": {
    fontSize: "54px !important"
  },
  "@media (prefers-reduced-motion)": {
    transform: "none"
  },
  borderRadius: 10,
  boxShadow: `-6px 6px 0 ${ColorCostcoBlue}`,
  display: "block",
  fontFamily: '"GothamMedium", "Helvetica Neue", "Helvetica Neue LT Pro", Helvetica, arial, sans-serif',
  height: "100%",
  overflow: "hidden",
  padding: SpaceMd,
  textDecoration: "none"
});
const StyledCalloutContainer = styled(StyledLinkContainer)({
  "& div": {
    textAlign: "left"
  },
  "& h2": {
    fontSize: "54px !important"
  },
  boxShadow: `-6px 6px 0 ${ColorCostcoBlue}`,
  padding: SpaceMd
});
const StyledTitleContainer = styled(Box)({
  "& h2": {
    fontSize: FontSize600,
    fontWeight: FontWeightBold,
    lineHeight: FontLineHeightSm,
    margin: 0
  }
});
const StyledFeatureContainer = styled(Box)({
  [MEDIA_QUERY_SMALL]: {
    alignItems: "center",
    flexDirection: "column",
    gap: SpaceMd
  },
  alignItems: "flex-start",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-evenly",
  padding: `${SpaceLg} ${SpaceMd}`
});
const StyledFeatureGroup = styled(Box)({
  [MEDIA_QUERY_SMALL]: {
    ".feature-text": {
      textAlign: "left",
      width: "100%"
    },
    div: {
      flex: "1",
      width: "50px"
    },
    flexDirection: "row",
    gap: SpaceMd,
    width: "80%"
  },
  alignContent: "center",
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  fontWeight: FontWeightBold,
  gap: SpaceXxs,
  justifyContent: "center",
  textAlign: "center",
  width: "30%"
});
const StyledFeatureImage = styled(GenericImageHandler)({
  "@media (prefers-reduced-motion)": {
    transform: "none !important"
  },
  filter: "drop-shadow(0 -20px 20px rgba(0, 0, 0, 0.2))",
  height: 50,
  transitionDuration: ".1s",
  transitionProperty: "transform",
  width: 50
});
const StyledShopNowContainer = styled(Box)({
  padding: 5
});
const StyledShopNowButton = styled(Box)({
  "&:hover": {
    background: `${ColorWhite} !important`,
    color: `${ColorBlack} !important`,
    transition: ".25s ease-in-out"
  },
  borderRadius: 3,
  display: "inline-block",
  fontSize: "1rem",
  fontWeight: 400,
  padding: `6px ${SpaceMd}`,
  width: "auto"
});
export {
  DEFAULT_CALLOUT_BACKGROUND_COLOR,
  DEFAULT_CALLOUT_TEXT_COLOR,
  HEADER_HEIGHT,
  HEADER_ICON_HEIGHT,
  MAX_TILE_WIDTH,
  StyledBodyContainer,
  StyledCalloutContainer,
  StyledFeatureContainer,
  StyledFeatureGroup,
  StyledFeatureImage,
  StyledHeaderContainer,
  StyledLinkContainer,
  StyledShopNowButton,
  StyledShopNowContainer,
  StyledStaticCalloutContainer,
  StyledTileContainer,
  StyledTitleContainer,
  StylesIconContainer
};
